module.exports = __webpack_public_path__ + "static/img/8.b49a005.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/8.png
// module id = pGtJ
// module chunks = 4